import defaultValues from '../lib/defaultValues.js'

const state = {
  loginMode: defaultValues.loginMode
}

const getters = {
  getLoginMode: (state) => {
    return state.loginMode
  }
}

const mutations = {
  updateLoginMode: (state, loginMode) => {
    state.loginMode = loginMode
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loginModal.js